export default __webpack_public_path__ + "static/media/greece.8184028d.jpg";